import { render, staticRenderFns } from "./ResourcesMonitoringSingleHeader.vue?vue&type=template&id=5dcabf06&"
import script from "./ResourcesMonitoringSingleHeader.vue?vue&type=script&lang=js&"
export * from "./ResourcesMonitoringSingleHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports